"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var Instantiable_abstract_1 = require("../Instantiable.abstract");

var apiPath = '/api/v1/brizo/services';

var Brizo = function (_super) {
  __extends(Brizo, _super);

  function Brizo(config) {
    var _this = _super.call(this) || this;

    _this.setInstanceConfig(config);

    return _this;
  }

  Object.defineProperty(Brizo.prototype, "url", {
    get: function get() {
      return this.config.brizoUri;
    },
    enumerable: true,
    configurable: true
  });

  Brizo.prototype.getVersionInfo = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.ocean.utils.fetch.get(this.url)];

          case 1:
            return [2, _a.sent().json()];
        }
      });
    });
  };

  Brizo.prototype.getPurchaseEndpoint = function () {
    return "" + this.url + apiPath + "/access/initialize";
  };

  Brizo.prototype.getConsumeEndpoint = function () {
    return "" + this.url + apiPath + "/consume";
  };

  Brizo.prototype.getEncryptEndpoint = function () {
    return "" + this.url + apiPath + "/publish";
  };

  Brizo.prototype.getComputeEndpoint = function (pubKey, serviceId, _notUsed, container) {
    return "" + this.url + apiPath + "/compute";
  };

  Brizo.prototype.initializeServiceAgreement = function (did, serviceAgreementId, serviceDefinitionId, signature, consumerAddress) {
    return __awaiter(this, void 0, void 0, function () {
      var args, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            args = {
              did: did,
              serviceAgreementId: serviceAgreementId,
              serviceDefinitionId: serviceDefinitionId,
              signature: signature,
              consumerAddress: consumerAddress
            };
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4, this.ocean.utils.fetch.post(this.getPurchaseEndpoint(), decodeURI(JSON.stringify(args)))];

          case 2:
            return [2, _a.sent()];

          case 3:
            e_1 = _a.sent();
            this.logger.error(e_1);
            throw new Error('HTTP request failed');

          case 4:
            return [2];
        }
      });
    });
  };

  Brizo.prototype.consumeService = function (agreementId, serviceEndpoint, account, files, destination, index) {
    if (index === void 0) {
      index = -1;
    }

    return __awaiter(this, void 0, void 0, function () {
      var signature, _a, filesPromises;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, account.getToken()];

          case 1:
            _a = _b.sent();
            if (_a) return [3, 3];
            return [4, this.ocean.utils.signature.signText(utils_1.noZeroX(agreementId), account.getId())];

          case 2:
            _a = _b.sent();
            _b.label = 3;

          case 3:
            signature = _a;
            filesPromises = files.filter(function (_, i) {
              return index === -1 || i === index;
            }).map(function (_a) {
              var i = _a.index;
              return __awaiter(_this, void 0, void 0, function () {
                var consumeUrl, e_2;
                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      consumeUrl = serviceEndpoint;
                      consumeUrl += "?index=" + i;
                      consumeUrl += "&serviceAgreementId=" + utils_1.noZeroX(agreementId);
                      consumeUrl += "&consumerAddress=" + account.getId();
                      consumeUrl += "&signature=" + signature;
                      _b.label = 1;

                    case 1:
                      _b.trys.push([1, 3,, 4]);

                      return [4, this.ocean.utils.fetch.downloadFile(consumeUrl, destination, i)];

                    case 2:
                      _b.sent();

                      return [3, 4];

                    case 3:
                      e_2 = _b.sent();
                      this.logger.error('Error consuming assets');
                      this.logger.error(e_2);
                      throw e_2;

                    case 4:
                      return [2];
                  }
                });
              });
            });
            return [4, Promise.all(filesPromises)];

          case 4:
            _b.sent();

            return [2, destination];
        }
      });
    });
  };

  Brizo.prototype.encrypt = function (did, signature, document, publisher) {
    return __awaiter(this, void 0, void 0, function () {
      var args, response, e_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            args = {
              documentId: did,
              signature: signature,
              document: JSON.stringify(document),
              publisherAddress: publisher
            };
            _a.label = 1;

          case 1:
            _a.trys.push([1, 4,, 5]);

            return [4, this.ocean.utils.fetch.post(this.getEncryptEndpoint(), decodeURI(JSON.stringify(args)))];

          case 2:
            response = _a.sent();

            if (!response.ok) {
              throw new Error('HTTP request failed');
            }

            return [4, response.text()];

          case 3:
            return [2, _a.sent()];

          case 4:
            e_3 = _a.sent();
            this.logger.error(e_3);
            throw new Error('HTTP request failed');

          case 5:
            return [2];
        }
      });
    });
  };

  return Brizo;
}(Instantiable_abstract_1.Instantiable);

exports.Brizo = Brizo;